import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import { APP } from "../../../Definition";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import {
  exchangeSchoolYearPath,
  newNextYearStudentPath,
  editNextYearStudentPath,
  Context,
  fetchNextYearStudents,
  fetchClasses,
  fetchNextClasses,
  bulkEditNextYearStudentsPath,
  resetStudentPassword,
  masqueradeStudent,
  disableStudentPlans,
  MASQUERADE_STUDENT_SUCCESS_MESSAGE,
  FETCH_CLASSES_SUCCESS_MESSAGE,
  FETCH_NEXT_CLASSES_SUCCESS_MESSAGE,
  bulkRegisterNextYearStudentsPath,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import StudentList from "../../../templates/manager/StudentList";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [loginCalling, loginPeep] = useWaitApiCall(state);
  const [resetPasswordCalling, resetPasswordPeep] = useWaitApiCall(state);
  const history = useHistory();
  const { currentYear, nextYear } = useCurrentYear();
  const [fetched, setFetched] = React.useState({
    classes: false,
    next_classes: false,
  });
  React.useEffect(() => {
    dispatch(fetchNextYearStudents());
    dispatch(fetchClasses(currentYear));
    dispatch(fetchNextClasses(currentYear + 1));
  }, [dispatch, currentYear]);

  const resetPasswordFunc = React.useCallback(
    (id: number) => dispatch(resetPasswordPeep(resetStudentPassword(id))),
    [dispatch, resetPasswordPeep],
  );

  const saveDisableStudentPlans = (id: number, end_at: string) => {
    dispatch(disableStudentPlans(id, end_at));
  };

  const toBuildNewStudent = React.useCallback(
    () => history.push(newNextYearStudentPath),
    [history],
  );
  const toBuildBulkNewStudents = React.useCallback(
    () => history.push(bulkRegisterNextYearStudentsPath),
    [history],
  );
  const toBulkEditStudents = React.useCallback(
    () => history.push(bulkEditNextYearStudentsPath),
    [history],
  );

  const toBuildStudent = React.useCallback(
    id => {
      history.push(`${editNextYearStudentPath}/${id}`);
    },
    [history],
  );

  const dlpLoginFunc = React.useCallback(
    (id: number) => {
      dispatch(loginPeep(masqueradeStudent(id, APP["dlp"])));
    },
    [dispatch, loginPeep],
  );

  React.useEffect(() => {
    if (state.success_message === MASQUERADE_STUDENT_SUCCESS_MESSAGE) {
      window.open(
        `${process.env.REACT_APP_STUDENT_DLP_URL}/st?session_id=${state.temporary_session_id}`,
        "_blank",
      );
    }
    if (state.success_message === FETCH_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, classes: true }));
      }, 100);
    }
    if (state.success_message === FETCH_NEXT_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, next_classes: true }));
      }, 100);
    }
  }, [state.success_message, state.success_result, state.temporary_session_id]);

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.exchangeSchoolYear, to: exchangeSchoolYearPath },
        ]}
        currentTitle={`${titles.nextYearStudents} (${nextYear}年度)`}
      />
      {fetched.classes && fetched.next_classes && (
        <StudentList
          title={`${titles.nextYearStudents} (${nextYear}年度)`}
          loginCalling={loginCalling}
          resetPasswordCalling={resetPasswordCalling}
          resetPassword={resetPasswordFunc}
          toBuildNewStudent={toBuildNewStudent}
          toBulkEditStudents={toBulkEditStudents}
          toBuildBulkNewStudents={toBuildBulkNewStudents}
          toBuildStudent={toBuildStudent}
          students={state.next_year_students}
          classes={state.classes}
          next_classes={state.next_classes}
          school={state.manager.school!}
          isNextYear={true}
          dlpLogin={dlpLoginFunc}
          onSaveDisableStudentPlans={saveDisableStudentPlans}
        />
      )}
    </div>
  );
};
